<template>
    <div class="ZhiFa">
  <div class="box"><img src="@/assets/image/liu.png" alt=""></div>
  
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
img{
  width: 920px;
}
</style>